/**
 * @file Logging helpers (for wrapping wvus-client-logger or other logging related functions).
 */

import WvusClientLogger from "wvus-client-logger";

export const LOGGLY_KEY = "9efe753f-4e93-47dc-bac5-fce47cde0293";

export function getClientLoggerInstance() {
  // Return instance if it exist
  if (globalThis.wvusLogger) {
    return globalThis.wvusLogger;
  }

  // Create new instance
  const environment = window.location.host;
  const webproperty = "wvusFlexCheckout";
  const source = `wvusFlexCheckout - ${window.location.pathname}`;
  const sendConsoleErrors = true;

  const windowWvusLogger = new WvusClientLogger({
    logglyKey: LOGGLY_KEY,
    webProperty: webproperty,
    env: environment,
    source: source, // Optional
    sendConsoleErrors: sendConsoleErrors
  });

  globalThis.wvusLogger = windowWvusLogger;
  return globalThis.wvusLogger;
}

export const wvusLogger = getClientLoggerInstance();
